<template>
  <div class="header__navbar--profile">
    <div @click="toggleMostrar">
      <Avatar :image="null" :color="'#000'" :letters="'LI'" />
    </div>
    <div class="header__navbar--profile-backdrop" v-if="mostrar" @click="toggleMostrar"></div>
    <nav class="header__navbar--profile-actions" v-if="mostrar">
      <ul>
        <li>
          <router-link to="/"> Editar perfil </router-link>
        </li>
        <li>
          <a href="#" @click.prevent="logout"> Cerrar sesion </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { app } from "@/core/app";
import { currentUser } from "@/core/users/session";
import Avatar from "./Avatar.vue";

export default {
  computed: {
    user() {
      return currentUser();
    },
  },
  data() {
    return {
      mostrar: false,
    };
  },
  watch: {
    $route(to, from) {
      this.mostrar = false;
    },
  },
  methods: {
    toggleMostrar: function () {
      this.mostrar = !this.mostrar;
    },
    logout: function () {
      const form = document.createElement("form");
      const token = document.createElement("input");

      form.method = "POST";
      form.action = "/logout";

      token.type = "hidden";
      token.name = "_token";
      token.value = app().csrfToken;

      form.appendChild(token);
      document.body.appendChild(form);
      form.submit();
    },
  },
  components: {
    Avatar,
  },
};
</script>

<style scoped></style>
